import { useQuery } from "@tanstack/react-query";
import { ActionsTable } from "Common/Components";
import React, { useMemo, useState } from "react";
import { DeleteDepartament, FetchDepartament } from "services";
import { useDepartamentStore } from "../../store";
import { Departament } from "interfaces";
import { NotificationType, showNotifications } from "helpers/toas_notification";
import { useTranslation } from "react-i18next";

export const useDepartamentList = () => {
  const { setDepartament, setIsEdit, setIsOpenModal, isOpenModal } =
    useDepartamentStore();
  const [modalDelete, setModalDelete] = useState<boolean>(false);
  const [departamentId, setDepartamentId] = useState<number>(0);
  const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      {
        header: "ID",
        accessorKey: "index",
        cell: (cell: any) => cell.row.index + 1,
        enableColumnFilter: false,
      },
      {
        header: t("departament.table.columns.description"),
        accessorKey: "description",
        enableColumnFilter: false,
      },
      {
        header: t("departament.table.columns.actions"),
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => {
          const rowData = cell.row.original;
          return (
            <ActionsTable
              onClickEdith={() => {
                handleEdit(rowData);
              }}
              onClickDelete={() => {
                handleDelete(rowData);
              }}
            />
          );
        },
      },
    ],
    []
  );

  const handleDelete = (data: Departament) => {
    setDepartamentId(data.id);
    setModalDelete(true);
  };
  const handleEdit = (data: Departament) => {
    setIsEdit(true);
    setIsOpenModal(true);
    setDepartament(data);
  };

  const { data: departamentList, refetch: refetchDepartament } = useQuery({
    queryKey: ["departament"],
    queryFn: FetchDepartament,
  });

  const deleteDepartament = async () => {
    try {
      setIsSubmiting(true)
      if (departamentId === 0) return;

      const response = await DeleteDepartament(departamentId);

      if (response.code === "200") {
        setModalDelete(false);
        refetchDepartament();
        showNotifications(
          NotificationType.SUCCESS,
          t("deleteModal.succedDelete")
        );
      } else {
        showNotifications(
          NotificationType.ERROR,
          t("deleteModal.errorDelete" + response.message)
        );
      }
    } catch (error) {
      showNotifications(NotificationType.ERROR, t("deleteModal.errorDelete"));
    }finally{
      setIsSubmiting(false)
    }
  };

  return {
    columns,
    departament: departamentList?.data,
    refetchDepartament,
    modalDelete,
    setModalDelete,
    deleteDepartament,
    setIsOpenModal,
    isOpenModal,
    setDepartament,
    t,
    isSubmiting
  };
};
